import { render, staticRenderFns } from "./AyudaParte1CultivoCosecha.vue?vue&type=template&id=0f5a8392&scoped=true"
import script from "./AyudaParte1CultivoCosecha.vue?vue&type=script&lang=js"
export * from "./AyudaParte1CultivoCosecha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5a8392",
  null
  
)

export default component.exports